import { useStore } from '@stores';
import { useEffect } from 'react';

/**
 * The build's unified history log - every job's changes, collected in one page and ordered by
 * when they happened rather than by which job they were on.
 */
export const useMasterBuildHistory = (masterBuildId?: string) => {
  const { masterBuildStore } = useStore();
  const {
    history,
    historyTotalCount,
    historySkipCount,
    historyMaxResultCount,
    historyCurrentPage,
    historyLoading,
    setHistoryPage,
  } = masterBuildStore;

  useEffect(() => {
    if (!masterBuildId) return;
    masterBuildStore.getHistory({
      masterBuildId,
      maxResultCount: historyMaxResultCount,
      skipCount: historySkipCount,
    });
  }, [masterBuildId, historySkipCount, historyMaxResultCount]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => () => masterBuildStore.clearHistory(), [masterBuildStore]);

  return {
    history,
    totalCount: historyTotalCount,
    currentPage: historyCurrentPage,
    maxResultCount: historyMaxResultCount,
    loading: historyLoading,
    setPage: setHistoryPage,
  };
};
